import React, { useEffect, useState } from 'react';
import { Container, Typography, CircularProgress, Box } from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from "react-i18next";

const ConfirmEmail = () => {
  const { token } = useParams(); // URL'deki token'ı alıyoruz
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(true); // Yükleme animasyonu için state
  const navigate = useNavigate();
  const { t } = useTranslation();

  const api = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
  });

  useEffect(() => {
    const confirmEmail = async () => {
      try {
        // Token'ı backend'e göndererek e-postayı doğruluyoruz
        const response = await api.post(`/api/auth/confirm-email`, { token });
        setMessage(response.data.message);

        // E-posta doğrulama başarılı olduğunda projects sayfasına yönlendir
        navigate('/projects');
      } catch (error) {
        setMessage(t("email.confirmation_failed", {
          error: error.response?.data?.message || ""
        }));
      } finally {
        setLoading(false); // Yükleme animasyonunu durdur
      }
    };

    confirmEmail();
  }, [token, navigate]);

  return (
    <Container maxWidth="sm">
      <Box mt={5} textAlign="center">
        {loading ? (
          <>
            <CircularProgress />
            <Typography mt={2}>{t("confirming_email")}</Typography>
          </>
        ) : (
          <Typography variant="h5" color={message.includes('failed') ? 'error' : 'primary'}>
            {message}
          </Typography>
        )}
      </Box>
    </Container>
  );
};

export default ConfirmEmail;
